module.exports = __webpack_public_path__ + "components/flag/static/square/tk-61c809f2a31cfbc09168b2b932c8175b.svg";